import InternetExplorer from './InternetExplorer';
import Minesweeper from './Minesweeper';
import ErrorBox from './ErrorBox';
import MyComputer from './MyComputer';
import Notepad from './Notepad';
import Winamp from './Winamp';
import Paint from './Paint';
import Msn from './Msn';
import SilkRoad from './SilkRoad';
import Cmd from './Cmd';
import Milkie from './Milkie';
import Services from './Services';
import Projects from './Projects';
import DarkIRC from './DarkIRC';
import cmd from 'assets/windowsIcons/cmd.png';
import silkroad from 'assets/windowsIcons/silkroad.png';
import msn from 'assets/windowsIcons/msn.png';
import milkie from 'assets/milkieverse.avif';
import iePaper from 'assets/windowsIcons/ie-paper.png';
import ie from 'assets/windowsIcons/ie.png';
import mine from 'assets/minesweeper/mine-icon.png';
import error from 'assets/windowsIcons/897(16x16).png';
import computer from 'assets/windowsIcons/676(16x16).png';
import computerLarge from 'assets/windowsIcons/676(32x32).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import winamp from 'assets/windowsIcons/winamp.png';
import paintLarge from 'assets/windowsIcons/680(32x32).png';
import paint from 'assets/windowsIcons/680(16x16).png';
import documents from 'assets/windowsIcons/308(32x32).png';

const gen = () => {
  let id = -1;
  return () => {
    id += 1;
    return id;
  };
};
const genId = gen();
const genIndex = gen();
export const defaultAppState = [
  {
    component: SilkRoad,
    header: {
      title: 'Silkroad V1 - Anonymous Marketplace',
      icon: silkroad,
    },
    defaultSize: {
      width: 800,
      height: 800,
    },
    defaultOffset: {
      x: 130,
      y: 20,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Cmd,
    header: {
      title: 'BTCminer.bat',
      icon: cmd,
    },
    defaultSize: {
      width: 700,
      height: 792,
    },
    defaultOffset: {
      x: 250,
      y: 40,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Winamp,
    header: {
      title: 'Winamp',
      icon: winamp,
      invisible: true,
    },
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 0,
      y: 0,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: DarkIRC,
    header: {
      title: 'DarkIRC',
      icon: cmd,
    },
    defaultSize: {
      width: 1015,
      height: 700,
    },
    defaultOffset: {
      x: 550,
      y: 150,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    id: genId(),
    zIndex: genIndex(),
  },
  {
    component: Services,
    header: {
      title: 'Services.txt',
      icon: notepad,
    },
    defaultSize: {
      width: 600,
      height: 550,
    },
    defaultOffset: {
      x: 450,
      y: 250,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    id: genId(),
    zIndex: genIndex(),
  },
];

export const defaultIconState = [
  {
    id: 0,
    icon: computerLarge,
    title: 'My Computer',
    component: MyComputer,
    isFocus: false,
  },
  {
    id: 1,
    icon: ie,
    title: 'Internet Explorer',
    component: InternetExplorer,
    isFocus: false,
  },
  {
    id: 2,
    icon: winamp,
    title: 'Winamp',
    component: Winamp,
    isFocus: false,
  },
  {
    id: 3,
    icon: paintLarge,
    title: 'Paint',
    component: Paint,
    isFocus: false,
  },
  {
    id: 4,
    icon: msn,
    title: 'MSN',
    component: Msn,
    isFocus: false,
  },
  {
    id: 5,
    icon: silkroad,
    title: 'Silkroad',
    component: SilkRoad,
    isFocus: false,
  },
  {
    id: 6,
    icon: cmd,
    title: 'BTCminer.bat',
    component: Cmd,
    isFocus: false,
  },
  {
    id: 7,
    icon: milkie,
    title: 'Milkieverse',
    component: Milkie,
    isFocus: false,
  },
  {
    id: 8,
    icon: notepadLarge,
    title: 'Services',
    component: Services,
    isFocus: false,
  },
  {
    id: 9,
    icon: documents,
    title: 'Projects',
    component: Projects,
    isFocus: false,
  },
  {
    id: 10,
    icon: cmd,
    title: 'DarkIRC',
    component: DarkIRC,
    isFocus: false,
  },
];

export const appSettings = {
  'Internet Explorer': {
    header: {
      icon: iePaper,
      title: 'InternetExplorer',
    },
    component: InternetExplorer,
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: 140,
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Minesweeper: {
    header: {
      icon: mine,
      title: 'Minesweeper',
    },
    component: Minesweeper,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 190,
      y: 180,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  'My Computer': {
    header: {
      icon: computer,
      title: 'My Computer',
    },
    component: MyComputer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 260,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Projects: {
    header: {
      icon: documents,
      title: 'My Projects',
    },
    component: Projects,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 260,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Notepad: {
    header: {
      icon: notepad,
      title: 'Untitled - Notepad',
    },
    component: Notepad,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 270,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Services: {
    header: {
      icon: notepad,
      title: 'Services.txt',
    },
    component: Services,
    defaultSize: {
      width: 600,
      height: 550,
    },
    defaultOffset: {
      x: 450,
      y: 300,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Winamp: {
    header: {
      icon: winamp,
      title: 'Winamp',
      invisible: true,
    },
    component: Winamp,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 0,
      y: 0,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Paint: {
    header: {
      icon: paint,
      title: 'Untitled - Paint',
    },
    component: Paint,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Msn: {
    header: {
      icon: msn,
      title: 'Msn',
    },
    component: Msn,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  SilkRoad: {
    header: {
      icon: silkroad,
      title: 'Silkroad',
    },
    component: SilkRoad,
    defaultSize: {
      width: 800,
      height: 800,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Cmd: {
    header: {
      icon: cmd,
      title: 'Miner.bat',
    },
    component: Cmd,
    defaultSize: {
      width: 700,
      height: 792,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Milkie: {
    header: {
      icon: milkie,
      title: 'Milkieverse.cc',
    },
    component: Milkie,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  DarkIRC: {
    header: {
      icon: cmd,
      title: 'DarkIRC',
    },
    component: DarkIRC,
    defaultSize: {
      width: 1015,
      height: 700,
    },
    defaultOffset: {
      x: 550,
      y: 150,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
};

export {
  InternetExplorer,
  Minesweeper,
  ErrorBox,
  MyComputer,
  Notepad,
  Winamp,
  Msn,
};
